import * as React from 'react';
// import '../../styles/main.scss'
import {useEffect} from "react";

/**
 * 
 * Ticket # : 7674
 * Change # : Remove CSS from Set Deployed and move to default
 * Change : Pankaj
 * Date   : 13 Feb 2023
 */
function DeployedToEverywhere(props) {
    useEffect(() => {
        props.SetDeployedToEverywhereLoaded(true)
    }, []);

    return (
        <></>
    )
};

export default DeployedToEverywhere;